import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';
import {
  IonButton,
  IonContent,
  IonIcon,
  IonSpinner,
  ModalController,
} from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { alertCircleOutline, refreshOutline } from 'ionicons/icons';

import { ProfileService } from '../../pages/profile/profile.service';
import { Profile } from '../../pages/profile/profile.model';

@Component({
  selector: 'app-profile-error-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './profile-error.modal.html',
  styleUrls: ['./profile-error.modal.scss'],
  imports: [IonContent, IonIcon, IonButton, IonSpinner],
})
export class ProfileErrorModal {
  private profileService = inject(ProfileService);
  private modalCtrl = inject(ModalController);
  private cdr = inject(ChangeDetectorRef);

  retrying = false;
  retryFailed = false;

  constructor() {
    addIcons({
      'alert-circle-outline': alertCircleOutline,
      'refresh-outline': refreshOutline,
    });
  }

  async retry(): Promise<void> {
    this.retrying = true;
    this.retryFailed = false;
    this.cdr.markForCheck();

    try {
      const profile: Profile = await this.profileService.loadProfile();
      await this.modalCtrl.dismiss(profile, 'confirm');
    } catch {
      this.retrying = false;
      this.retryFailed = true;
      this.cdr.markForCheck();
    }
  }
}
